import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';

import finalUrlTemplate from './final-url-template.pug';
import { ViewModel } from './final-url-viewmodel';

export class FinalUrlView extends Backbone.View {
  initialize(options = {}) {
    this.options = options;
    _.defaults(this.options, {
      template: finalUrlTemplate,
      isFinal: true,
    });
    this.ko_model = new ViewModel(this.options);

    this.ko_model.isFinalUrl.subscribe((newValue) => {
      if (newValue === true) {
        this.trigger('finalUrlSelected');
      } else {
        this.trigger('destinationUrlSelected');
      }
    });
  }

  render() {
    this.$el.html(finalUrlTemplate({
      i18n: this.options.i18n,
    }));

    ko.applyBindings(this.ko_model, this.el);
    return this;
  }

  getValues() {
    return {
      isFinal: this.ko_model.isFinalUrl(),
    };
  }
}
